import { render } from "./EmailOfferPDF.vue?vue&type=template&id=d177489c&scoped=true"
import script from "./EmailOfferPDF.vue?vue&type=script&lang=js"
export * from "./EmailOfferPDF.vue?vue&type=script&lang=js"

import "./EmailOfferPDF.vue?vue&type=style&index=0&id=d177489c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d177489c"
/* hot reload */
if (module.hot) {
  script.__hmrId = "d177489c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d177489c', script)) {
    api.reload('d177489c', script)
  }
  
  module.hot.accept("./EmailOfferPDF.vue?vue&type=template&id=d177489c&scoped=true", () => {
    api.rerender('d177489c', render)
  })

}

script.__file = "src/components/EmailOfferPDF.vue"

export default script